"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ClearIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenConfig = require("@8x8/oxygen-config");

var Styled = _interopRequireWildcard(require("../styled"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ClearIndicator = function ClearIndicator(_ref) {
  var rest = _extends({}, _ref);

  var _rest$theme = rest.theme,
      clearIconColor = _rest$theme.clearIconColor,
      clearIconFocusedColor = _rest$theme.clearIconFocusedColor,
      testId = rest.selectProps.testId,
      isFocused = rest.isFocused;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.ClearIndicator, rest, /*#__PURE__*/_react["default"].createElement(Styled.CloseIcon, _extends({
    isFocused: isFocused,
    color: isFocused ? clearIconFocusedColor : clearIconColor
  }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_CLEAR_INDICATOR")))));
};

exports.ClearIndicator = ClearIndicator;
ClearIndicator.propTypes = {
  isFocused: _propTypes["default"].bool
};
ClearIndicator.defaultProps = {
  isFocused: false
};

var _default = (0, _oxygenConfig.withTheme)(ClearIndicator, 'select');

exports["default"] = _default;